import { useState, useEffect, useCallback } from "react";
import api from "../utils/api";
import toast from "react-hot-toast";

export function useDriverRequests(status = "pending", type, enabled = true, driverId) {
  const [requests, setRequests] = useState([]);
  const [loading,  setLoading]  = useState(true);

  const load = useCallback(async () => {
    if (!enabled) { setLoading(false); return; }
    setLoading(true);
    try {
      const params = new URLSearchParams({ status });
      if (type) params.set("type", type);
      if (driverId) params.set("driverId", driverId);
      const { data } = await api.get(`/api/driver-requests?${params}`);
      setRequests(data);
    } catch (err) {
      toast.error(err.response?.data?.error || "Failed to load requests");
    } finally {
      setLoading(false);
    }
  }, [status, type, enabled, driverId]);

  useEffect(() => { load(); }, [load]);

  async function approve(id, note) {
    const { data } = await api.post(`/api/driver-requests/${id}/approve`, { note });
    setRequests(prev => prev.filter(r => r.id !== id));
    return data;
  }

  async function reject(id, note) {
    const { data } = await api.post(`/api/driver-requests/${id}/reject`, { note });
    setRequests(prev => prev.filter(r => r.id !== id));
    return data;
  }

  return { requests, loading, approve, reject, reload: load };
}
